/**
 * v0 by Vercel.
 * トロフィーアイコン
 */
export default function TrophyIcon({ className = "w-4 h-4" }: { className?: string; }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      aria-hidden="true"
    >
      <g>
        <path
				       d="M510.782,102.014c-4.184-26.144-15.726-45.621-34.31-57.89C460.262,33.42,439.79,28.666,413.805,29.76
		c-0.192-0.008-0.362-0.004-0.555-0.012c1.109-9.41,1.902-16.222,2.283-19.504l0.258-1.988h-0.028
		c0.012-0.102,0.029-0.242,0.029-0.242h-159.25h-8.848H105.84L88.686,7.986l0.002,0.027h-0.24c0,0,0.867,7.5,2.301,19.68
		l0.188,1.801c-22.953,0.113-41.318,5.101-56.072,15.039C16.393,56.975,5.03,76.557,1.082,102.736
		c-5.404,35.863,9.646,72.797,40.254,98.797c22.68,19.266,50.242,29.816,78.367,30.778c21.102,49.031,97.027,92.25,97.027,107.64
		c0,16.996,0,61.559,0,61.692v0.012h-43.904h-0.09l0,0h-0.24v54.359H128.26v48h123.86h123.861v-47.566v-0.191l0,0v-0.242h-44.236
		v-54.359h-44.236c0,0,0-44.684,0-61.703c0-15.348,75.504-58.371,96.848-107.234c1.219,0.035,2.436,0.066,3.652,0.066
		c29.959,0,59.5-10.91,83.424-31.613C501.801,174.893,516.512,137.826,510.782,102.014z M443.936,169.393
		c-13.705,11.855-30.08,18.852-46.963,20.726c-1.287,0.125-2.568,0.285-3.871,0.352c4.738-33.902,10.531-80.558,15.078-118.215
		c20.23-1.816,35.363,0.48,45.135,6.934c8.469,5.59,13.694,15.23,15.971,29.461C472.7,129.998,463.225,152.701,443.936,169.393z
		 M201.135,175.94l-0.15,69.785c-1.576-1.274-33.192-27-39.662-49.641c-6.635-23.222-9.951-132.703-9.951-132.703h49.764V175.94z
		 M68.543,169.506c-19.441-16.516-29.123-39.133-25.902-60.508c2.144-14.254,7.283-23.937,15.699-29.609
		c8.49-5.719,21.09-8.305,37.64-7.781c4.133,34.23,9.301,75.934,13.783,108.852c0.385,2.965,0.772,5.972,1.137,8.789
		C95.7,186.795,81.047,180.123,68.543,169.506z" 
          className="fill-current"
        />
      </g>
    </svg>
  );
}